const popupName = 'camsConfirmation';

export default {
    bind(el, binding, vnode) {
        if (!binding.value) {
            return;
        }

        const camsApi = vnode.context.$root.camsApi;
        if (!camsApi.needsConfirmation) {
            return;
        }

        const urlParams = {zone: binding.value};

        if (camsApi.sPopup) {
            el.addEventListener(binding.arg || 'click', e => {
                e.preventDefault();
                vnode.context.showPopup(popupName, urlParams);
            });
        } else if (el.tagName.toLowerCase() === 'a') {
            el.setAttribute('target', '_blank');
            el.setAttribute('href', camsApi.makeAcceptUrl(urlParams));
        }
    }
}
